'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('webaccess-list-ss', {
      url: '/webaccess/list/ss',
      template: '<webaccess-list-ss></webaccess-list-ss>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/webaccess/list-ss/webaccess-list-ss.routes.js